/* eslint-disable */
import React, { useCallback, useMemo } from 'react';
import { connect } from 'dva';
import { openInBrowser } from '@/utils/bridge';
import { TEMPLATE_B } from '../config/pars';
import styles from '../styles/index.less';

const toRuleDetail = (url = '') => {
  openInBrowser({
    url,
  });
};

const BizItem = ({
  bizData: {
    detail,
    detail_v2,
    template_type,
    biz_name,
    biz_id,
    business_title,
    reward_desc,
    request_desc_multi,
    detail_url,
    business_tag,
  },
  handleJoinBtnClick,
  reportBtnClick,
  isFinish,
}) => {
  const isTemplateB = useMemo(() => template_type === TEMPLATE_B, [template_type]);
  const capacityList = useMemo(() => (isTemplateB ? detail_v2 : detail), [
    isTemplateB,
    detail,
    detail_v2,
  ]);
  const renderBtnText = useCallback(() => (isFinish ? '已招满' : '立即加入'), [isFinish]);

  const business_tag_arr = useMemo(() => {
    if (business_tag) {
      const arr = business_tag.split(',');

      // mix_isp类型的标签
      const hasMixIsp = arr.some(item => item.startsWith('mix_isp'));
      if (hasMixIsp) {
        // 非mix_isp的保留，mix_isp类型归并成一个
        const nonMixIspArr = arr.filter(item => !item.startsWith('mix_isp'));
        return [...nonMixIspArr, 'mix_isp'];
      }

      // 没有mix_isp，原样返回
      return arr;
    }
    return [];
  }, [business_tag]);

  // 标签样式映射，参考图中颜色
  const TAG_STYLE_MAP = {
    provincial: { background: '#fff1f0', color: '#ff4d4f' }, // 可同省调度
    peak: { background: '#f9f0ff', color: '#722ed1' }, // 可限制时段
    internet_ipv6: { background: '#e6f7ff', color: '#2f54eb' }, // 可纯跑IPv6
    mix_isp: { background: '#e6fffb', color: '#13c2c2' }, // 可异网交付
    disable_tcp: { background: '#f6ffed', color: '#52c41a' }, // 可纯跑UDP
  };

  const jumpToDetail = useCallback(() => {
    reportBtnClick('requirement', { type: biz_id });
    if (detail_url) toRuleDetail(detail_url);
  }, [biz_id, detail_url]);

  return (
    <>
      <div className={`${styles['part']} ${isFinish ? styles['finish'] : ''}`} id={`biz${biz_id}`}>
        <label className={styles['part-tit']}>{business_title || biz_name}</label>
        <p style={{ textAlign: 'center', fontSize: '14px', marginBottom: '10px' }}>
          {business_tag_arr.map(item => {
            let type = null;
            if (item.startsWith('intra_provincial')) type = 'intra_provincial';
            if (item.startsWith('internet_ipv6')) type = 'internet_ipv6';
            if (item.startsWith('mix_isp')) type = 'mix_isp';
            if (item.startsWith('disable_tcp')) type = 'disable_tcp';
            if (type) {
              const style = TAG_STYLE_MAP[type];
              const textMap = {
                intra_provincial: '可同省调度',
                internet_ipv6: '可纯跑IPv6',
                mix_isp: '可异网交付',
                disable_tcp: '可纯跑UDP',
              };
              return (
                <span
                  key={`${item}-${type}`}
                  className={styles['reward_desc_tag']}
                  style={style}
                >
                  {textMap[type]}
                </span>
              );
            }
            return null;
          })}
          {business_tag_arr.some(item => item.indexOf('peak') > -1) && (
            <span
              className={styles['reward_desc_tag']}
              style={TAG_STYLE_MAP.peak}
            >
              可限制时段
            </span>
          )}
        </p>
        <p className={styles['p1']}>{reward_desc}</p>
        <div className={styles['rules']}>
          <p className={styles['rules-tit']}>资源要求</p>
          <div
            className={styles['rule-list']}
            dangerouslySetInnerHTML={{ __html: request_desc_multi }}
          />
        </div>
        {isTemplateB
          ? capacityList?.length > 0 && (
              <table className={styles['table']}>
                <thead>
                  <tr>
                    <th style={{ width: '.95rem' }}>区域</th>
                    <th>省份</th>
                    <th style={{ width: '1rem' }}>运营商</th>
                    <th style={{ width: '.8rem' }}>需求容量</th>
                  </tr>
                </thead>
                <tbody>
                  {capacityList.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row.area}</td>
                      <td>{row.province.split(',').join('、')}</td>
                      <td>{row.isp}</td>
                      <td>{row.capacity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          : capacityList?.length > 0 && (
              <table className={styles['table']}>
                <thead>
                  <tr>
                    <th style={{ width: '.95rem' }}>区域</th>
                    <th>省份</th>
                    <th style={{ width: '.8rem' }}>电信</th>
                    <th style={{ width: '.8rem' }}>联通</th>
                    <th style={{ width: '.8rem' }}>移动</th>
                  </tr>
                </thead>
                <tbody>
                  {capacityList.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{row.area}</td>
                      <td>{row.province.split(',').join('、')}</td>
                      <td>{row.tel}</td>
                      <td>{row.unicom}</td>
                      <td>{row.mobile}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        <div className={styles['btns']}>
          <button
            className={`${styles['btn-guide']} ${isFinish ? styles['disabled'] : ''}`}
            onClick={jumpToDetail}
            disabled={isFinish}
          >
            上机指南
          </button>
          <button
            className={`${styles['btn-join']} ${isFinish ? styles['disabled'] : ''}`}
            onClick={() => handleJoinBtnClick(biz_id)}
            disabled={isFinish}
          >
            {renderBtnText()}
          </button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, null)(BizItem);
